<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-row>
            <v-col>
                <v-tooltip top :disabled="!overlay">
                    <template v-slot:activator="{ on }">
                <v-card
                        class="mx-auto"
                        max-width="500"
                        v-on="on"
                >
                            <v-overlay :value="overlay" color="white" absolute></v-overlay>
                    <v-sheet class="pa-4 primary lighten-2" v-show="ifShowSearch">
                        <v-text-field
                                v-model="search"
                                label="Search Company Directory"
                                dark
                                flat
                                solo-inverted
                                hide-details
                                clearable
                                clear-icon="mdi-close-circle-outline"
                        ></v-text-field>
                        <v-checkbox
                                v-model="caseSensitive"
                                dark
                                hide-details
                                label="Case sensitive search"
                        ></v-checkbox>
                    </v-sheet>
                    <v-card-text style="height:550px">
                        <v-treeview
                                v-model="selections"
                                :active.sync="singleArr"
                                :open="openData"
                                :items="items"
                                :selectable="selectable"
                                :activatable="!selectable"
                                item-key="id"
                                :open-on-click="openOnClick"
                                :load-children="loadChildren"
                                @update:active="updateActive"
                                item-disabled="locked"
                                :selection-type="selectionType"
                                :open-all="openAll"
                                @input="modelSelection"
                                :filter="filter"
                                :search="search"
                                :return-object="returnObject"
                        >
                            <template v-slot:prepend="{ item,selected }" >
                                <v-icon v-if="item.iconType == 0">
                                    {{ item.icon }}
                                </v-icon>
                                <v-avatar v-else-if="item.iconType == 1" size="30px">
                                    <img :src=iconShow(item.icon) />
                                </v-avatar>
                            </template>
                        </v-treeview>
                    </v-card-text>
                </v-card>
                    </template>
                    <span> {{ $vuetify.lang.t('$vuetify.custom.disabled') }}</span>
                </v-tooltip>
            </v-col>
        </v-row>
    </v-container>
</template>
<style></style>
<script>
  export default {
    model: {
      prop: 'value',
      event: 'parent-event'
    },
    props:{
      value:{
          type: Array
      },
      items:{
          require:true,
          type:Array,
      },
      selectable:{
         type: Boolean,
         default:false //默认能只能选一个节点 true则可选多个节点
      },
      open:Array,
      openOnClick:{
          type:Boolean,
          default: true
      },
      selectionType:{
          type:String,
          default: 'leaf'
      },
      openAll:{
          type:Boolean,
          default: false
      },
      active:{
          type:Array,
      },
      selection:{
          type:Array,
      },
      ifBackPid:{
          type: Boolean,
          default: false
      },
      ifShowSearch:{
          type: Boolean,
          default: false
      },
      overlay:{
          type: Boolean,
          default: false
      },
      returnObject:{
          type: Boolean,
          default: false
      },
    },
    watch:{
        open(val){
            this.openData = val
        },
        active(val){
            this.singleArr = val;
            // let arr = this.getParent(this.items,val[0]);
            // let _this = this
            // _this.openData = []
            // arr.forEach(function (value, index, array) {
            //     _this.openData.push(value)
            // })
        },
        singleArr:{
            //单选返回返回值
            handler(newValue,oldValue){
                if(this.selectable)return
                this.$emit('parent-event',newValue);
                if(newValue.length != 0){
                    this.$emit('selectedVal',newValue);
                }else{
                    this.$emit('selectedOldVal');
                }
            }
        },
        selections:{
            //单选返回返回值
            handler(newValue,oldValue){
                if(!this.selectable)return;
                let _this = this;
                if(_this.ifBackPid){
                    let newArr = [];
                    newValue.forEach(function (value,index,array) {
                        let curr = _this.getParent(_this.items,value);
                        curr.forEach(function (value, index, array) {
                            if(!newArr.includes(value)){
                                newArr.push(value)
                            }
                        })

                    });
                    this.$emit('selectedVal',newArr);
                    this.$emit('parent-event',newArr);
                }else {
                    this.$emit('selectedVal',newValue);
                    this.$emit('parent-event',newValue);
                }
            }
        },
    },
    data () {
        return {
            singleArr: this.active,
            selections:this.value,
            search: null,
            caseSensitive: false,
            openData:this.open,
            alreadyOpen:[],
        }
    },
    computed: {
        filter () {
            return this.caseSensitive
                ? (item, search, textKey) => item[textKey].indexOf(search) > -1
                : undefined
        },
        iconShow(icon){
            return function(icon) {
                if (icon.length == 32) {
                    return this.$file.fileDownload(icon)
                }
                return icon
            }
        },
    },
    methods:{
        modelSelection(val){
            this.$emit('parent-event',val);
        },
        updateActive(item){
            //点击事件
        },
        loadChildren(item){
            this.$emit('loadLazyTree',item);
        },
        getParent(data2, nodeId2) {
            let arrRes = [];
            if (data2.length == 0) {
                if (!!nodeId2) {
                    arrRes.unshift(nodeId2);
                }
                return arrRes;
            }
            let rev = (data, nodeId) => {
                for (let i = 0, length = data.length; i < length; i++) {
                    let node = data[i];
                    if (node.id == nodeId) {
                        arrRes.unshift(nodeId);
                        rev(data2, node.pid);
                        break;
                    }
                    else {
                        if (!!node.children) {
                            rev(node.children, nodeId);
                        }
                    }
                }
                return arrRes;
            };
            arrRes = rev(data2, nodeId2);
            return arrRes;
        },
    }
  }
</script>
